import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';

const METRIC_SELECTION = 'Metric Selection';

const trackMetricSelection = createTrackerForCategory(METRIC_SELECTION);

export const trackMetricSelectionCategorySelected = (properties: { categoryName: string }) => {
  trackMetricSelection('Metric Selection Category Selected', properties);
};

export const trackMetricSelectionUnselectAllClicked = () => {
  trackMetricSelection('Metric Selection Unselect All Clicked');
};

export const trackMetricSelectionCreateActionClicked = () => {
  trackMetricSelection('Metric Selection Create Action Clicked');
};

export const trackMetricSelectionSearchQueried = (properties: { searchQuery: string }) => {
  trackMetricSelection('Metric Selection Search Queried', properties);
};

export const trackMetricSelectionLinkToFullResourceClicked = (properties: { kind: 'metric' | 'metricGroup' }) => {
  trackMetricSelection('Metric Selection Link to Full Resource Clicked', properties);
};

export const trackMetricSelectionClosed = (properties: {
  selectedMetrics: string[];
  selectedMetricGroups: string[];
  openDuration: number;
}) => {
  trackMetricSelection('Metric Selection Closed', properties);
};

export const trackMetricSelectionFirstInteraction = (properties: {
  interactionType: 'search' | 'category' | 'select' | 'create';
}) => {
  trackMetricSelection('Metric Selection First Interaction', properties);
};

export const trackMetricSelectionItemSelected = (properties: {
  itemType: 'metric' | 'metricGroup';
  itemKey: string;
  categoryName: string;
  searchQuery: string;
}) => {
  trackMetricSelection('Metric Selection Item Selected', properties);
};
